/**
 * Gestione Pratiche API
 * Servizi per la gestione della piattaforma Gestione Pratiche
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddUserDTO } from '../model/addUserDTO';
import { Anagrafica } from '../model/anagrafica';
import { AuthorityDTO } from '../model/authorityDTO';
import { ComuneInfoDTO } from '../model/comuneInfoDTO';
import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { GenericResponseDTO } from '../model/genericResponseDTO';
import { InfoUtenteDTO } from '../model/infoUtenteDTO';
import { InlineResponse500 } from '../model/inlineResponse500';
import { UpdateAnagraficaDTO } from '../model/updateAnagraficaDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UserControllerService {

    protected basePath = 'http://comune.southengineering.it/gestione-pratiche';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Consente l&#x27;aggiunta di un nuovo utente e di assegnargli specifici ruoli
     * @param id_slug_comune 
     * @param email 
     * @param id_negozio 
     * @param authority_types 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addUserForm(id_slug_comune: string, email?: string, id_negozio?: string, authority_types?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public addUserForm(id_slug_comune: string, email?: string, id_negozio?: string, authority_types?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public addUserForm(id_slug_comune: string, email?: string, id_negozio?: string, authority_types?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public addUserForm(id_slug_comune: string, email?: string, id_negozio?: string, authority_types?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling addUser.');
        }




        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = canConsumeForm;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (email !== undefined) {
            formParams = formParams.append('email', <any>email) as any || formParams;
        }
        if (id_negozio !== undefined) {
            formParams = formParams.append('id_negozio', <any>id_negozio) as any || formParams;
        }
        if (authority_types) {
            authority_types.forEach((element) => {
                formParams = formParams.append('authority_types', <any>element) as any || formParams;
            })
        }

        return this.httpClient.request<GenericResponseDTO>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/user/add`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente l&#x27;aggiunta di un nuovo utente e di assegnargli specifici ruoli
     * @param body 
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addUser2(body: AddUserDTO, id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public addUser2(body: AddUserDTO, id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public addUser2(body: AddUserDTO, id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public addUser2(body: AddUserDTO, id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addUser2.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling addUser2.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GenericResponseDTO>('post',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/user/add-user`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di abilitare/disabilitare un utente
     * @param id_slug_comune 
     * @param username 
     * @param enable 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public enableDisableUser(id_slug_comune: string, username: string, enable: boolean, observe?: 'body', reportProgress?: boolean): Observable<InfoUtenteDTO>;
    public enableDisableUser(id_slug_comune: string, username: string, enable: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InfoUtenteDTO>>;
    public enableDisableUser(id_slug_comune: string, username: string, enable: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InfoUtenteDTO>>;
    public enableDisableUser(id_slug_comune: string, username: string, enable: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling enableDisableUser.');
        }

        if (username === null || username === undefined) {
            throw new Error('Required parameter username was null or undefined when calling enableDisableUser.');
        }

        if (enable === null || enable === undefined) {
            throw new Error('Required parameter enable was null or undefined when calling enableDisableUser.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (enable !== undefined && enable !== null) {
            queryParameters = queryParameters.set('enable', <any>enable);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<InfoUtenteDTO>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/user/${encodeURIComponent(String(username))}/enable`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente ad un utente (cassiere) di conoscere i comuni su cui è abilitato con almeno un tipo pratica
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getComuniCassiere(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ComuneInfoDTO>>;
    public getComuniCassiere(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ComuneInfoDTO>>>;
    public getComuniCassiere(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ComuneInfoDTO>>>;
    public getComuniCassiere(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getComuniCassiere.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ComuneInfoDTO>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/user/comuni`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di conoscere l&#x27;anagrafica di un utente
     * @param id_slug_comune 
     * @param anagrafica_id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserAnagrafica(id_slug_comune: string, anagrafica_id: string, observe?: 'body', reportProgress?: boolean): Observable<Anagrafica>;
    public getUserAnagrafica(id_slug_comune: string, anagrafica_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Anagrafica>>;
    public getUserAnagrafica(id_slug_comune: string, anagrafica_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Anagrafica>>;
    public getUserAnagrafica(id_slug_comune: string, anagrafica_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getUserAnagrafica.');
        }

        if (anagrafica_id === null || anagrafica_id === undefined) {
            throw new Error('Required parameter anagrafica_id was null or undefined when calling getUserAnagrafica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Anagrafica>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/user/${encodeURIComponent(String(anagrafica_id))}/anagrafica`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente a qualsiasi utente di conoscere il proprio profilo
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserInfo(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<InfoUtenteDTO>;
    public getUserInfo(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InfoUtenteDTO>>;
    public getUserInfo(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InfoUtenteDTO>>;
    public getUserInfo(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getUserInfo.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<InfoUtenteDTO>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/user/me`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente la visualizzazione di tutti gli utenti (visibili al ruolo del chiamante)
     * @param id_slug_comune 
     * @param codice_pratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listUsers(id_slug_comune: string, codice_pratica?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<InfoUtenteDTO>>;
    public listUsers(id_slug_comune: string, codice_pratica?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InfoUtenteDTO>>>;
    public listUsers(id_slug_comune: string, codice_pratica?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InfoUtenteDTO>>>;
    public listUsers(id_slug_comune: string, codice_pratica?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling listUsers.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codice_pratica !== undefined && codice_pratica !== null) {
            queryParameters = queryParameters.set('codice_pratica', <any>codice_pratica);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<InfoUtenteDTO>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/user/list`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di eseguire il logout ed invalidare il token utente
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public logout(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public logout(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public logout(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public logout(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling logout.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/user/logout`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di inviare una mail di reset password per un utente
     * @param id_slug_comune 
     * @param username 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resetPasswordUser(id_slug_comune: string, username: string, observe?: 'body', reportProgress?: boolean): Observable<InfoUtenteDTO>;
    public resetPasswordUser(id_slug_comune: string, username: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InfoUtenteDTO>>;
    public resetPasswordUser(id_slug_comune: string, username: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InfoUtenteDTO>>;
    public resetPasswordUser(id_slug_comune: string, username: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling resetPasswordUser.');
        }

        if (username === null || username === undefined) {
            throw new Error('Required parameter username was null or undefined when calling resetPasswordUser.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<InfoUtenteDTO>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/user/${encodeURIComponent(String(username))}/resetPassword`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di inviare una mail di reset password per un utente
     * @param id_slug_comune 
     * @param username 
     * @param password 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setPasswordUser(id_slug_comune: string, username: string, password: string, observe?: 'body', reportProgress?: boolean): Observable<InfoUtenteDTO>;
    public setPasswordUser(id_slug_comune: string, username: string, password: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InfoUtenteDTO>>;
    public setPasswordUser(id_slug_comune: string, username: string, password: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InfoUtenteDTO>>;
    public setPasswordUser(id_slug_comune: string, username: string, password: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling setPasswordUser.');
        }

        if (username === null || username === undefined) {
            throw new Error('Required parameter username was null or undefined when calling setPasswordUser.');
        }

        if (password === null || password === undefined) {
            throw new Error('Required parameter password was null or undefined when calling setPasswordUser.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (password !== undefined && password !== null) {
            queryParameters = queryParameters.set('password', <any>password);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<InfoUtenteDTO>('put',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/user/${encodeURIComponent(String(username))}/setPassword`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di modificare l&#x27;anagrafica di un utente
     * @param body 
     * @param id_slug_comune 
     * @param anagrafica_id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateUserAnagrafica(body: UpdateAnagraficaDTO, id_slug_comune: string, anagrafica_id: string, observe?: 'body', reportProgress?: boolean): Observable<Anagrafica>;
    public updateUserAnagrafica(body: UpdateAnagraficaDTO, id_slug_comune: string, anagrafica_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Anagrafica>>;
    public updateUserAnagrafica(body: UpdateAnagraficaDTO, id_slug_comune: string, anagrafica_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Anagrafica>>;
    public updateUserAnagrafica(body: UpdateAnagraficaDTO, id_slug_comune: string, anagrafica_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateUserAnagrafica.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling updateUserAnagrafica.');
        }

        if (anagrafica_id === null || anagrafica_id === undefined) {
            throw new Error('Required parameter anagrafica_id was null or undefined when calling updateUserAnagrafica.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Anagrafica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/user/${encodeURIComponent(String(anagrafica_id))}/anagrafica`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di modificare l&#x27;anagrafica di un utente ed il voucher annesso
     * @param body 
     * @param id_slug_comune 
     * @param anagrafica_id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateUserAnagraficaAndVoucher(body: UpdateAnagraficaDTO, id_slug_comune: string, anagrafica_id: string, observe?: 'body', reportProgress?: boolean): Observable<Anagrafica>;
    public updateUserAnagraficaAndVoucher(body: UpdateAnagraficaDTO, id_slug_comune: string, anagrafica_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Anagrafica>>;
    public updateUserAnagraficaAndVoucher(body: UpdateAnagraficaDTO, id_slug_comune: string, anagrafica_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Anagrafica>>;
    public updateUserAnagraficaAndVoucher(body: UpdateAnagraficaDTO, id_slug_comune: string, anagrafica_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateUserAnagraficaAndVoucher.');
        }

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling updateUserAnagraficaAndVoucher.');
        }

        if (anagrafica_id === null || anagrafica_id === undefined) {
            throw new Error('Required parameter anagrafica_id was null or undefined when calling updateUserAnagraficaAndVoucher.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Anagrafica>('patch',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/user/${encodeURIComponent(String(anagrafica_id))}/anagrafica-and-voucher`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente la visualizzazione di tutti i ruoli assegnabili ad un utente
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersRoles(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AuthorityDTO>>;
    public usersRoles(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AuthorityDTO>>>;
    public usersRoles(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AuthorityDTO>>>;
    public usersRoles(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling usersRoles.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<AuthorityDTO>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/user/manageable-roles`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
